import { useTranslation } from 'react-i18next';
export function useContactManagementTranslation() {
    return useTranslation('contact-management');
}
